import * as React from 'react';
import type { TollPreviewDataResponseData } from 'contracts/transport-routes';
import { useTranslation } from 'hooks';
import {
  Table,
  TableHead,
  TableHeader,
  TableBody,
  TableCell, TableRow,
} from 'components/ui/table';
import { Skeleton } from 'components/ui/skeleton';
import { moeda } from 'utils';

import { translations } from './translations';

type Props = {
  tolls?: TollPreviewDataResponseData['tolls'];
  loading?: boolean;
}

export const TollsList = ({ tolls, loading }: Props) => {
  const { getTranslation: t } = useTranslation(translations);

  if (!Array.isArray(tolls) || loading) {
    return <TollsListSkeleton />;
  }

  if (tolls.length === 0) {
    return <p>{t('emptyTollsListMessage')}</p>;
  }

  return (
    <Table>
      <TollsTableHeader />
      <TableBody>
        {tolls.map((toll) => (
          <TableRow key={toll.Ordem}>
            <TableCell>{toll.Ordem}</TableCell>
            <TableCell>{toll.NomePedagio}</TableCell>
            <TableCell>{moeda(+toll.Valor)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

const TollsListSkeleton = () => {
  return (
    <Table>
      <TollsTableHeader />
      <TableBody>
        {Array.from({ length: 8 }).map((_, index) => (
          <TableRow key={index}>
            <TableCell><Skeleton className={'w-4 h-4'} /></TableCell>
            <TableCell><Skeleton className={'w-40 h-4'} /></TableCell>
            <TableCell><Skeleton className={'w-20 h-4'} /></TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

const TollsTableHeader = () => {
  const { getTranslation: t } = useTranslation(translations);

  return (
    <TableHeader>
      <TableRow>
        <TableHead className={'w-14'}>{t('order')}</TableHead>
        <TableHead className={'w-[240px]'}>{t('place')}</TableHead>
        <TableHead>{t('value')}</TableHead>
      </TableRow>
    </TableHeader>
  );
};

